module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden",
    attrs: {
      "id": "measureOptions"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toolTypeSelected),
      expression: "toolTypeSelected"
    }],
    staticClass: "hidden",
    attrs: {
      "id": "measureToolType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.toolTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "length"
    }
  }, [_vm._v("Length (LineString)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "area"
    }
  }, [_vm._v("Area (Polygon)")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbb8231a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Measure.vue
// module id = 644
// module chunks = 2